module.exports = __webpack_public_path__ + "static/img/example-3.a69adc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-3.png
// module id = aFgU
// module chunks = 2